import ajax from '@/wrapper/ajax'
import { mapActions, mapMutations } from 'vuex'
import Constants from '@/Constants'

export default {
  // 현재 검색컴포넌트가 수정시 원하지 않는데,데이터 동기화가 이루어짐
  // TODO: 해결후 해당  부분 삭제 필요
  methods: {
    ...mapActions({
      setNewToken: 'users/setNewToken'
    }),
    ...mapMutations({
      setEvalParam: 'users/SET_EVAL_PARAM',
      setEvalPeriod: 'eval/SET_SELECTED_EVAL_TYPE'
    }),
    async checkVow (_data) {
      if (_data.evalRole === 'ASSISTANT') {
        await this.setNewToken(_data.evalDeptEvaluatorOid).then(() => {
          this.setEvalInfos(_data)
        })
      } else {
        this.setNewToken(_data.evalDeptEvaluatorOid).then(() => {
          ajax(
            'GET',
            this.isProfessor(_data.evalRole)
              ? `/api/head-professor/vows/${_data.evalDeptEvaluatorOid}`
              : `/api/evaluator/vows/${_data.evalDeptEvaluatorOid}`
          ).then(_res => {
            _res.isVowed
              ? this.setEvalInfos(_data)
              : this.$router.push({
                name: 'eval-vow',
                params: { vowParam: _data }
              })
          })
        })
      }
    },
    isDocument (_data) {
      if (this.isProfessor(_data.evalRole)) {
        if (this.$route.fullPath === '/dept/assessor-status') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'dept-assessor-status' })
        }
      } else if (this.isEvaluator(_data.evalRole)) {
        if (this.$route.fullPath === '/eval/asses') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'eval-asses' })
        }
      } else if (_data.evalRole === 'ASSISTANT') {
        if (this.$route.fullPath === '/dept/assessor-status') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'dept-assessor-status' })
        }
      }
    },
    isInterview (_data) {
      if (this.isProfessor(_data.evalRole)) {
        if (this.$route.fullPath === '/dept/assessor-status-final') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'dept-assessor-status-final' })
        }
      } else if (this.isEvaluator(_data.evalRole)) {
        if (this.$route.fullPath === '/eval/asses') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'eval-asses' })
        }
      } else if (_data.evalRole === 'ASSISTANT') {
        if (this.$route.fullPath === '/dept/assessor-status-final') {
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'dept-assessor-status-final' })
        }
      }
    },
    setEvalInfos (_data) {
      this.setEvalPeriod(_data.evalType)
      this.setEvalParam(_data)
      if (_data.evalType === 'DOCUMENT') {
        this.isDocument(_data)
      } else {
        this.isInterview(_data)
      }
    },
    isProfessor (evalRole) {
      return Constants.EVAL_ROLE_TYPE.PROFESSOR === evalRole
    },
    isEvaluator (evalRole) {
      return Constants.EVAL_ROLE_TYPE.EVALUATOR === evalRole
    },
    isAssistant (evalRole) {
      return Constants.EVAL_ROLE_TYPE.ASSISTANT === evalRole
    }
  }
}
